
// import React, { useEffect, useState } from "react";
// import { Tooltip } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import { Link, useNavigate } from "react-router-dom";
// import PaginationComponent from "../../../Components/PaginationComponent";
// import toast from 'react-hot-toast';
// import incomeService from "../../../Services/incomeService";
// import medicineService from "../../../Services/medicineService";
// import medicalServices from "../../../Services/medicalServices";
// import saleService from "../../../Services/saleService";


// const PatientSalesAll = () => {
//   const [searchData, setSearchData] = useState("");
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [filteredData, setFilteredData] = useState([]);
//   const [paginatedData, setPaginatedData] = useState([]);
//   const itemsPerPage = 10;
//   const [currentPage, setCurrentPage] = useState(1);
//   const [patients, setPatients] = useState([]);
//   const [loading, setLoading] = useState(false);
  

//   useEffect(() => {
//     const getPSales = async () => {
//       try {
//         setLoading(true);
//         const response = await saleService.fetchAllPSales();
//         const sortedSales = response.sales.sort((a, b) => new Date(b.date) - new Date(a.date));
//         setPatients(sortedSales);
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         console.error("Error fetching sales:", error);
//       }
//     };
//     getPSales();
//   }, []);

//   useEffect(() => {
//     const filteredResult =
//       patients?.filter((item) => {
//         const itemDate = new Date(item?.date);
//         const normalizedItemDate = new Date(
//           itemDate.getFullYear(),
//           itemDate.getMonth(),
//           itemDate.getDate()
//         );
  
//         const normalizedStartDate = startDate
//           ? new Date(new Date(startDate).setHours(0, 0, 0, 0))
//           : null;
//         const normalizedEndDate = endDate
//           ? new Date(new Date(endDate).setHours(23, 59, 59, 999))
//           : null;
  
//         const isWithinDateRange =
//           (!normalizedStartDate || normalizedStartDate <= normalizedItemDate) &&
//           (!normalizedEndDate || normalizedItemDate <= normalizedEndDate);

//         const matchesPatientOrDoctor =
//         item?.full_name?.toLowerCase().includes(searchData.toLowerCase()) ||
//         item?.receptionist_name?.toLowerCase().includes(searchData.toLowerCase()) ||
//         item?.name?.toLowerCase().includes(searchData.toLowerCase());
  
//         return (
          
//           matchesPatientOrDoctor && isWithinDateRange
//         );
//       }) || [];
  
//     setFilteredData(filteredResult);
//     setCurrentPage(1);
//   }, [searchData, startDate, endDate, patients]);
  

//   useEffect(() => {
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     setPaginatedData(filteredData?.slice(startIndex, endIndex) || []);
//   }, [currentPage, filteredData]);

//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     const options = { year: "numeric", month: "short", day: "numeric" };
//     return new Date(dateString).toLocaleDateString("en-US", options);
//   };

//   return (
//     <div>
//       <div className="p-4">
//         <h1 className="ml-[3%] text-[24px] text-gray-700 font-[700]">
//           Patient Sales Record
//         </h1>
//         <h1 className="ml-[3%] text-[9px] bg-[#F07F1B] py-[3px] text-center rounded-full w-24 text-white font-bold">
//           {filteredData?.length || 0} records found
//         </h1>

//         <div className="flex mt-8 flex-row-reverse justify-between ml-[3%]">
//           <div className="w-[40%]">
//             <input
//               type="search"
//               placeholder="Search Here..."
//               value={searchData}
//               onChange={(e) => setSearchData(e.target.value)}
//               className="block w-[90%] pl-10 text-gray-900 p-2 rounded-md border-gray-800 bg-white focus:outline-none"
//             />
//             <SearchIcon className="mt-[-4rem] text-gray-700 ml-2" />
//           </div>

//           <div className="space-x-4">
//             <input
//               type="date"
//               value={startDate}
//               onChange={(e) => setStartDate(e.target.value)}
//               className="bg-white text-black font-medium border py-2 px-4 rounded-full duration-300"
//               placeholder="Start Date"
//             />
//             <input
//               type="date"
//               value={endDate}
//               onChange={(e) => setEndDate(e.target.value)}
//               className="bg-white text-black font-medium border py-2 px-4 rounded-full duration-300"
//               placeholder="End Date"
//             />
//             <button
//               onClick={() => {
//                 setStartDate("");
//                 setEndDate("");
//               }}
//               className="bg-white text-[#F07F1B] font-semibold border hover:bg-[#F07F1B] hover:text-white py-2 px-8 rounded-full duration-300"
//             >
//               Show All
//             </button>
//           </div>
          
//         </div>

//         <div className="mx-[3%] rounded-lg">
//           <table className="w-[100%] rounded-lg overflow-hidden">
//             <thead className="bg-gray-700">
//               <tr className="text-white capitalize leading-normal text-[12px] text-left">
//                 <th className="py-4 w-[15%] pl-4">
//                   Invoice No.
//                 </th>
//                 <th className="py-4 w-[15%]">
//                   Patient Name
//                 </th>
//                 <th className="py-4 w-[15%]">
//                   Doctor Name
//                 </th>
//                 <th className="py-4 w-[15%] text-center">
//                   Amount Received
//                 </th>
//                 <th className="py-4 w-[15%] text-center">
//                 Recorded By
//                 </th>
//                 <th className="py-4 w-[15%] text-center">
//                   Checkup Date
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {paginatedData?.map((patient) => (
//                 <tr
//                   key={patient?.sale_id}
//                   className="bg-white text-gray-600 font-light border-t-[1px] border-gray-200 text-xs"
//                 >
//                   <td className="py-4 w-[15%] text-left">
//                     <p className="font-[600] text-gray-600 pl-4">
//                       {patient?.sale_id}
//                     </p>
//                   </td>
//                   <td className="py-4 w-[15%] text-left">
//                     <p className="font-[400] text-gray-600">
//                       {patient?.full_name}
//                     </p>
//                   </td>
//                   <td className="py-4 w-[15%] text-left">
//                     <p className="font-[600] text-gray-600">
//                       {patient?.name}
//                     </p>
//                   </td>
//                   <td className="py-4 px-2 w-[15%] text-center">
//                     <span className="font-[400]">{patient?.fee}</span>
//                   </td>
//                   <td className="py-4 px-2 w-[15%] text-center">
//                     <span className="font-[400]">{patient?.receptionist_name}</span>
//                   </td>
//                   <td className="py-4 px-2 w-[15%] text-center">
//                     <span className="font-[400]">
//                       {formatDate(patient?.date)}
//                     </span>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         <PaginationComponent
//           filteredData={filteredData}
//           setPaginatedData={setPaginatedData}
//           itemsPerPage={itemsPerPage}
//           currentPage={currentPage}
//           setCurrentPage={setCurrentPage}
//         />
//       </div>
//     </div>
//   );
// };

// export default PatientSalesAll;


import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import PaginationComponent from "../../../Components/PaginationComponent";
import toast from "react-hot-toast";
import saleService from "../../../Services/saleService";

const PatientSalesAll = () => {
  const [searchData, setSearchData] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getPSales = async () => {
      try {
        setLoading(true);
        const response = await saleService.fetchAllPSales();
        const sortedSales = response.sales.sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        );
        setPatients(sortedSales);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching sales:", error);
      }
    };
    getPSales();
  }, []);

  useEffect(() => {
    const filteredResult =
      patients?.filter((item) => {
        const itemDate = new Date(item?.date);
        const normalizedItemDate = new Date(
          itemDate.getFullYear(),
          itemDate.getMonth(),
          itemDate.getDate()
        );
        const normalizedStartDate = startDate
          ? new Date(new Date(startDate).setHours(0, 0, 0, 0))
          : null;
        const normalizedEndDate = endDate
          ? new Date(new Date(endDate).setHours(23, 59, 59, 999))
          : null;
        const isWithinDateRange =
          (!normalizedStartDate || normalizedStartDate <= normalizedItemDate) &&
          (!normalizedEndDate || normalizedItemDate <= normalizedEndDate);
        const matchesSearch =
          item?.full_name?.toLowerCase().includes(searchData.toLowerCase()) ||
          item?.receptionist_name?.toLowerCase().includes(searchData.toLowerCase()) ||
          item?.name?.toLowerCase().includes(searchData.toLowerCase());
        return matchesSearch && isWithinDateRange;
      }) || [];
    setFilteredData(filteredResult);
    setCurrentPage(1);
  }, [searchData, startDate, endDate, patients]);

  useEffect(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setPaginatedData(filteredData?.slice(startIndex, endIndex) || []);
  }, [currentPage, filteredData]);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };
    const formatTime = (dateString) => {
      if (!dateString) return "";
      return new Date(dateString).toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    };
  return (
    <div className="p-6">
      {/* HEADER */}
      <div className="flex items-center justify-between bg-white border border-gray-200 rounded-xl px-6 py-4 mb-5 shadow-sm">
        <div>
          <h1 className="text-[17px] font-[500] text-gray-800">Patient Sales Record</h1>
          <p className="text-[12px] text-gray-400 mt-0.5">
            {filteredData?.length || 0} records found
          </p>
        </div>

        <div className="flex items-center gap-3 flex-wrap justify-end">
          {/* Date Filters */}
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="text-[13px] bg-gray-50 border border-gray-200 rounded-lg px-3 py-[7px] focus:outline-none text-gray-700"
            title="Start Date"
          />
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="text-[13px] bg-gray-50 border border-gray-200 rounded-lg px-3 py-[7px] focus:outline-none text-gray-700"
            title="End Date"
          />
          {(startDate || endDate) && (
            <button
              onClick={() => { setStartDate(""); setEndDate(""); }}
              className="text-[13px] bg-gray-100 hover:bg-gray-200 text-gray-600 px-3 py-[7px] rounded-lg transition-colors"
            >
              Clear
            </button>
          )}

          {/* Search */}
          <div className="relative">
            <SearchIcon
              className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400"
              style={{ fontSize: 16 }}
            />
            <input
              type="search"
              placeholder="Search by patient or doctor..."
              value={searchData}
              onChange={(e) => setSearchData(e.target.value)}
              className="pl-8 pr-3 py-[7px] w-[220px] text-[13px] bg-gray-50 border border-gray-200 rounded-lg focus:outline-none"
            />
          </div>
        </div>
      </div>

      {/* TABLE */}
      <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
        <table className="w-full">
          <thead>
            <tr className="bg-gray-800 text-[11px] uppercase text-white">
              <th className="py-3 px-4 text-left">Invoice No.</th>
              <th className="py-3 px-4 text-center">Checkup Date</th>
              <th className="py-3 px-4 text-center">Checkup Time</th>
              <th className="py-3 px-4 text-left">Patient Name</th>
              <th className="py-3 px-4 text-left">Doctor Name</th>
              <th className="py-3 px-4 text-center">Amount Received</th>
              <th className="py-3 px-4 text-center">Recorded By</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={6} className="py-10 text-center text-gray-400 text-[13px]">
                  Loading...
                </td>
              </tr>
            ) : paginatedData?.length === 0 ? (
              <tr>
                <td colSpan={6} className="py-10 text-center text-gray-400 text-[13px]">
                  No records found
                </td>
              </tr>
            ) : (
              paginatedData?.map((patient) => (
                <tr
                  key={patient?.sale_id}
                  className="border-t hover:bg-gray-50 text-[13px]"
                >
                  <td className="py-3 px-4 text-gray-500">{patient?.sale_id}</td>
                   <td className="py-3 px-4 text-center text-gray-600">{formatDate(patient?.date)}</td>
                  <td className="py-3 px-4 text-center text-gray-600">{formatTime(patient?.created_at)}</td> 
                 <td className="py-3 px-4 font-[500] text-gray-800">{patient?.full_name}</td>
                  <td className="py-3 px-4 text-gray-600">{patient?.name}</td>
                  <td className="py-3 px-4 text-center text-gray-600">{patient?.fee}</td>
                  <td className="py-3 px-4 text-center text-gray-600">{patient?.receptionist_name}</td>
                 
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <PaginationComponent
        filteredData={filteredData}
        setPaginatedData={setPaginatedData}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
};

export default PatientSalesAll;